mutation TagGroupCreate($input: TagGroupCreateInput!) {
  tagGroupCreate(input: $input) {
    tagGroup {
      id
      _rowTimestamp
      name
      description
      _isUpdatable
      _isDeletable
      tagGroupItemsByTagGroupId {
        nodes {
          id
          tagId
          _rowTimestamp
          _tagBadgeName
          tag {
            badgeColor
          }
        }
      }
    }
  }
}
